export function IconCustomerInfo({ ...props }) {
  return (
    <svg
      {...props}
      viewBox="0 0 19.379 24.973"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="#fff">
        <path
          d="m33.816 5.629h-16.782a1.3 1.3 0 0 0 -1.3 1.3v22.371a1.3 1.3 0 0 0 1.3 1.3h16.782a1.3 1.3 0 0 0 1.3-1.3v-22.373a1.3 1.3 0 0 0 -1.3-1.3zm.3 23.674a.3.3 0 0 1 -.3.3h-16.781a.3.3 0 0 1 -.3-.3v-22.376a.3.3 0 0 1 .3-.3h16.782a.3.3 0 0 1 .3.3z"
          transform="translate(-15.735 -5.629)"
        />
        <path
          d="m39.295 55.449h-11.845a.617.617 0 0 0 0 1.233h11.845a.617.617 0 0 0 0-1.233z"
          transform="translate(-23.683 -41.645)"
        />
        <path
          d="m39.295 66.969h-11.845a.617.617 0 0 0 0 1.233h11.845a.617.617 0 0 0 0-1.233z"
          transform="translate(-23.683 -49.973)"
        />
        <path
          d="m39.295 78.488h-11.845a.617.617 0 0 0 0 1.233h11.845a.617.617 0 0 0 0-1.233z"
          transform="translate(-23.683 -58.408)"
        />
        <path
          d="m37.409 26.038a10.976 10.976 0 0 0 3.495.637 10.8 10.8 0 0 0 3.721-.545c.23-.145.236-.259.236-.259a1.978 1.978 0 0 0 -.525-1.882c-.206-.457-1.463-.853-1.463-.853-.469-.165-.612-.33-.656-.415a.262.262 0 0 1 -.012-.027s0-.01-.007-.026a2.218 2.218 0 0 1 -.062-.272s0 .013-.008.037a.984.984 0 0 1 0-.129.08.08 0 0 1 -.011.011 2.415 2.415 0 0 0 .366-.66 1.237 1.237 0 0 0 .216-.491c.095-.267.067-.4.023-.471a1.73 1.73 0 0 0 -.08-1.289 1.135 1.135 0 0 0 -.72-.743 2.124 2.124 0 0 0 -1.394-.137c-1.017.172-1.234 1.368-1.234 1.368a1.9 1.9 0 0 0 .091.9 1.116 1.116 0 0 0 .042.467.348.348 0 0 0 .163.283 2.326 2.326 0 0 0 .347.723.679.679 0 0 1 0 .2v-.019a1.512 1.512 0 0 1 -.066.245c-.047.064-.095.12-.141.173a5.463 5.463 0 0 1 -1.29.569 1.316 1.316 0 0 0 -.564.381 4.007 4.007 0 0 0 -.656 1.737c.009.439.2.486.2.486z"
          transform="translate(-31.359 -14.796)"
        />
      </g>
    </svg>
  );
}
